// Cajas del código OTP, un dígito por caja: avanza sola, regresa con Backspace y avisa al completar.
// La comparten el teléfono y el correo del paso 01 y el celular del carrito de accesorios.
import type { RefObject } from 'react';

/** Dígitos del código que manda messages-business. */
export const OTP_CODE_LENGTH = 4;

export const emptyOtpCode = (length = OTP_CODE_LENGTH): string[] => Array<string>(length).fill('');

export function OtpCodeBoxes({
    code,
    onCodeChange,
    onComplete,
    inputsRef,
    labelPrefix = 'Dígito',
    disabled = false,
}: {
    code: string[];
    onCodeChange: (next: string[]) => void;
    /** Se llama con el código completo al teclear el último dígito. */
    onComplete: (full: string) => void;
    /** Para que el dueño regrese el foco a la primera caja tras un rechazo. */
    inputsRef: RefObject<(HTMLInputElement | null)[]>;
    labelPrefix?: string;
    disabled?: boolean;
}) {
    const handleChange = (idx: number, value: string): void => {
        const digit = value.replace(/\D/g, '').slice(-1);
        const next = [...code];
        next[idx] = digit;
        onCodeChange(next);
        if (digit && idx < code.length - 1) inputsRef.current[idx + 1]?.focus();
        if (!next.includes('')) onComplete(next.join(''));
    };

    return (
        <>
            {code.map((digit, idx) => (
                <input
                    key={idx}
                    ref={(el) => {
                        inputsRef.current[idx] = el;
                    }}
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    disabled={disabled}
                    onChange={(e) => {
                        handleChange(idx, e.target.value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Backspace' && !code[idx] && idx > 0) {
                            inputsRef.current[idx - 1]?.focus();
                        }
                    }}
                    className="h-[48px] w-[38px] rounded-lg border border-input bg-background text-center text-[18px] font-bold tabular-nums outline-none transition-colors focus:border-ring disabled:cursor-not-allowed disabled:opacity-50 sm:h-[52px] sm:w-[44px] sm:text-[20px]"
                    aria-label={`${labelPrefix} ${String(idx + 1)}`}
                />
            ))}
        </>
    );
}
